module.exports = __webpack_public_path__ + "static/media/scampi.396ce4fa.jpg";